export const trackMinimumDistanceToWall = 20;
export const trackMinimumDistanceToKnot = 20;
export const knotMinimumDistanceToKnot = 20;
export const trackMinimumDistanceToTrack = 20;

export const knotOffsetForTrackConnection = 10;
export const defaultMaxKnotConnections = 3;
